import { getLocale } from "../runtime";

const sv_loadingpayment = /** @type {(inputs?: {}) => string} */ (inputs) => {
	return `Laddar betalning...`
};

const loadingpayment = /** @type {(inputs?: {}, options?: {locale?: string}) => string} */ (inputs = {}, options = {}) => {
	const locale = options.locale ?? getLocale();
	if (locale === "sv") return sv_loadingpayment(inputs)
	return "loadingPayment";
};

export { loadingpayment as "loadingPayment" };